module.exports = __webpack_public_path__ + "media/kr_web_15w.10633b8d.mp4";